{
  "customer-form-dialog": {
    "field": {
      "last_checkin": "Lần cuối checkin",
      "number_of_visit": "Số lần ghé thăm",
      "registered_since": "Ngày dăng ký",
      "type": "Kiểu khách"
    },
    "button": {
      "cancel": "Hủy bỏ",
      "submit": "Xác nhận"
    },
    "text": {
      "create_customer": "Tạo hồ sơ khách hàng mới",
      "create_customer_success": "Tạo mới thành công",
      "edit_customer": "Chỉnh sửa hồ sơ khách hàng",
      "edit_customer_success": "Cập nhật thành công"
    }
  }
}
